
import ogPagesMixins from '@/mixins/ogPagesMixins'
import isClient from '@/mixins/isClient'
export default {
  mixins: [ogPagesMixins, isClient],
  scrollToTop: true,
  props: {
    author: {
      type: Object,
      default: null,
    },
    statistics: {
      type: Object,
      default: null,
    },
    seoAuthorName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      products: null,
      productsLimit: 10,
      productsOffset: 0,
      productsCount: 0,
    }
  },
  async fetch() {
    if (this.author) await this.fetchProducts()
  },
  computed: {
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/author/vk/${this.author?.id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
    seoTitle() {
      return `${this.seoAuthorName}: акции | Мегасреда`
    },
    seoDescription() {
      return `Все акции ${this.author.type === 'COMPANY' ? 'компании' : ''} ${
        this.seoAuthorName
      } на Мегасреде`
    },
    seoH1() {
      return `Выгодные акции на продукты и сервисы от ${
        this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
      } ${this.seoAuthorName} размещённые на Мегасреде`
    },
  },
  methods: {
    loadMore() {
      this.productsOffset = this.productsOffset + this.productsLimit
      this.fetchProducts()
    },

    updateProduct() {
      this.products = null
      this.fetchProducts()
      this.$emit('update-offer')
    },
    removeProduct() {
      this.products = null
      this.fetchProducts()
      this.$emit('remove-offer')
    },

    async fetchProducts() {
      try {
        const { products, countAllPublishedProducts } = await this.$axios.$get(
          `/advertisements/vacancys/${this.author.id}`,
          {
            params: {
              limit: this.productsLimit,
              offset: this.productsOffset,
            },
          }
        )

        this.productsCount = countAllPublishedProducts
        if (this.products?.length) {
          this.products = this.products.concat(products)
        } else {
          this.products = products
        }
      } catch (error) {}
    },
  },
}
